module.exports = __webpack_public_path__ + "img/streamate.eacb7ef.png";